import React from 'react';
import moment from 'moment';

import ReactDatetime from 'react-datetime';

class InlineReplenishmentPeriodEditField extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            isEditing: false,
            origStartDate: moment(props.startDate),
            origEndDate: moment(props.endDate),
            startDate: moment(props.startDate),
            endDate: moment(props.endDate),
        };
        this.edit = this.edit.bind(this);
        this.cancel = this.cancel.bind(this);
        this.changeStartDate = this.changeStartDate.bind(this);
        this.changeEndDate = this.changeEndDate.bind(this);
        this.commit = this.commit.bind(this);
        this.formatDateUtc = this.formatDateUtc.bind(this);
        this.formatDateDe = this.formatDateDe.bind(this);
    }

    edit() {
        this.setState({isEditing: true})
    }

    cancel() {
        this.setState({isEditing: false, startDate: this.state.origStartDate, endDate: this.state.origEndDate});
    }

    changeStartDate(date) {
        this.setState({startDate: date});
    }

    changeEndDate(date) {
        this.setState({endDate: date});
    }

    commit() {
        const utcStart = this.formatDateUtc(this.state.startDate);
        const utcEnd = this.formatDateUtc(this.state.endDate);
        this.props.onCommit(utcStart, utcEnd);
        this.setState({isEditing: false});
    }

    formatDateUtc(date) {
        return date.format('YYYY-MM-DDTHH:mm:00');
    }

    formatDateDe(date) {
        return date.format('DD.MM.YYYY HH:mm');
    }

    render() {
        if (this.state.isEditing) {
            return (
                <div onClick={this.toggleEdit}>
                    <div className="input-group">
                        <ReactDatetime locale="de"
                                       value={this.formatDateDe(this.state.startDate)}
                                       dateFormat={'DD.MM.YYYY'}
                                       timeFormat={'HH:mm'}
                                       onChange={this.changeStartDate}/>
                        <ReactDatetime locale="de"
                                       value={this.formatDateDe(this.state.endDate)}
                                       dateFormat={'DD.MM.YYYY'}
                                       timeFormat={'HH:mm'}
                                       onChange={this.changeEndDate}/>

                        <div className="input-group-btn">
                            <button className="btn btn-success" onClick={this.commit}><i className="fa fa-check"/>&nbsp;</button>
                            <button className="btn btn-secondary"  onClick={this.cancel}><i className="fa fa-times" />&nbsp;</button>
                        </div>
                    </div>
                </div>
            )
        }
        return (
            <div onClick={this.edit}>
                <span>{this.formatDateDe(this.state.startDate)} - {this.formatDateDe(this.state.endDate)}</span>
            </div>
        );
    }
}

export default InlineReplenishmentPeriodEditField;



// WEBPACK FOOTER //
// ./src/admin/module/overview/InlineReplenishmentPeriodEditField.js